import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { AuthContext } from "../../context/authContext";

import { createUserAPIResponseType } from "./types";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { UpdateUserSchema } from "src/validation/updateUser";
import BAAComponent from "../baaComponent";
import AuthSubHeader from "../../components/authSubHeader";
import SignatureModal from "../../components/modals/signatureModals/addSignatureModal";
import AddSignatureButton from "../../components/addSignatureButton";
const HubUpdateUser: FC = (): JSX.Element => {
  const [isSignatureModalVisible, setIsSignatureModalVisible] = useState(false);
  const [userSignature, setUserSignature] = useState <string| null>(null);

  const { userData, sub_header, updateUserData } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);
  const { control, handleSubmit } = useForm({
    mode: "all",
    resolver: yupResolver(UpdateUserSchema),
    defaultValues: {
      firstname: userData?.firstname || "",
      middlename: userData?.middlename || "",
      lastname: userData?.lastname || "",
      email: userData?.email || ""
    }
  });





  const { loading: userLoading, data: updateUserApiResponse, mutate: addNewUser, error, removeErrorAndData } =
    useFetch<createUserAPIResponseType>(APIEndpoints.USER_UPDATE, {}, { userId: userData?.id });

  useEffect(() => {
    if (updateUserApiResponse) {
      const { code, message, data } = updateUserApiResponse.status;

      if (code === 200) {
        if (data) {
          const { user } = data;

          if (user) {
            showToast([message], ToastTypes.SUCCESS);

            //:- Runs if user has setup a new password and needs to login again
            updateUserData(user);
          }
        }
      } else if (code === 500) {
        showToast([message], ToastTypes.ERROR);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserApiResponse]);

  const submitForm = (values: unknown) => {
    if ((error && error.length > 0) || updateUserApiResponse) removeErrorAndData();
    addNewUser({ user: values });
  };






  const {
    data: signatureUploadResponse,
    error: signatureUploadError,
    mutate: uploadSignatureMutate,
    removeErrorAndData: clearSignatureState,
  } = useFetch<any>(APIEndpoints.UPDATE_SIGNATURE, {},{ id: userData?.id });

  const handleSaveSignature = async (file: File) => {
    clearSignatureState();
    const formData = new FormData();
    formData.append('global_doctor[signature_data]', file);
    formData.append('id', userData?.id?.toString() || '');
    formData.append('user',  'true');
    setUserSignature(URL.createObjectURL(file)); // show preview
    uploadSignatureMutate(formData);
    // console.log("file", file)
  };

  useEffect(() => {
    if (signatureUploadResponse || signatureUploadError) {
      if (signatureUploadResponse.status.code === 200) {
        showToast(['Signature uploaded successfully'], ToastTypes.SUCCESS);
      } else {
        showToast(['Failed to upload signature'], ToastTypes.ERROR);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signatureUploadResponse, signatureUploadError]);




  return (
    <div className="container-fluid d-flex flex-fill auth-page overflow-auto">
      <div className="container d-flex flex-column">
        <AuthSubHeader />

        <div className="flex-fill">
          <div className="card mt-4">
            <div className="card-header">
              <h1 className="mb-0">Edit Account</h1>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit(submitForm)}>
                <p className="fs-6">
                  You may edit your user account information here. Note that by using this platform, you accept and
                  agree
                  to the terms of the Business Associates Agreement below.
                </p>

                <Controller
                  name="firstname"
                  control={control}
                  defaultValue=""
                  render={({field, fieldState: {error}}) => (
                    <div className={"row"}>
                      <label className={"form-label col-12 col-lg-2"}>First Name</label>
                      <div className={"col-12 col-lg-8"}>
                        <HubInputField
                          inputId="firstname"
                          isRowBased={true}
                          isRequired={false}
                          field={field}
                          error={error}
                          // inputLabel="Firstname"
                          inputType="firstName"
                        />
                      </div>
                    </div>
                  )}
                />
                <Controller
                  name="middlename"
                  control={control}
                  defaultValue=""
                  render={({field, fieldState: {error}}) => (
                    <div className={"row"}>
                      <label className={"form-label col-12 col-lg-2"}>Middle Name</label>
                      <div className={"col-12 col-lg-8"}>
                        <HubInputField
                          inputId="middlename"
                          isRowBased={true}
                          isRequired={false}
                          field={field}
                          error={error}
                          // inputLabel="Middlename"
                          inputType="middleName"
                        />
                      </div>
                    </div>
                  )}
                />
                <Controller
                  name="lastname"
                  control={control}
                  defaultValue=""
                  render={({field, fieldState: {error}}) => (
                    <div className={"row"}>
                      <label className={"form-label col-12 col-lg-2"}>Last Name</label>
                      <div className={"col-12 col-lg-8"}>
                        <HubInputField
                          inputId="lastname"
                          isRowBased={true}
                          isRequired={false}
                          field={field}
                          error={error}
                          // inputLabel="Lastname"
                          inputType="lastName"
                        />
                      </div>
                    </div>
                  )}
                />
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({field, fieldState: {error}}) => (
                    <div className={"row"}>
                      <label className={"form-label col-12 col-lg-2"}>Email *</label>
                      <div className={"col-12 col-lg-8"}>
                        <HubInputField
                          inputId="email"
                          isRowBased={false}
                          isRequired={true}
                          field={field}
                          error={error}
                          // inputLabel="Email"
                          inputType="email"
                        />
                      </div>
                    </div>
                  )}
                />

                {/* <div className="card p-4 mb-2 bg-light-subtle border-light-subtle">
                  <h5 className="text-primary mb-0">Account Settings</h5>
                  <Controller
                    name="retreatment_reminders"
                    control={control}
                    defaultValue={false}
                    render={({ field: { value, onChange } }) => (
                      <div className="form-check mt-3">
                        <input
                          className="form-check-input" type="checkbox"
                          id="isSpecialityPharmacyOnlyCheckbox"
                          name="prescription_attributes.is_specialty_pharmacy_only"
                          checked={value}
                          onChange={(e) => onChange(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="isSpecialityPharmacyOnlyCheckbox">
                          Allow patient to receive Retreatment Reminders
                        </label>
                      </div>
                    )}
                  />
                </div> */}

                <div className="card">
                  <div className="card-header">
                    <h1 className="mb-0">Password</h1>
                  </div>
                  <div className={"card-body"}>
                    <p>
                      Password must be at least 10 characters long (no spaces) and include at least one uppercase
                      letter, at least three lowercase letters, one special character, and a number.
                    </p>

                    <Controller
                      name="password"
                      control={control}
                      defaultValue=""
                      render={({field, fieldState: {error}}) => (
                        <div className="row">
                          <label className="form-label col-12 col-lg-2">Password</label>
                          <div className="col-12 col-lg-8">
                            <HubInputField
                              inputId="password"
                              isRowBased={true}
                              isRequired={false}
                              field={field}
                              error={error}
                              // inputLabel="Password"
                              inputType="password"
                            />
                          </div>
                        </div>
                      )}
                    />
                    <Controller
                      name="password_confirmation"
                      control={control}
                      defaultValue=""
                      render={({field, fieldState: {error}}) => (
                        <div className="row">
                          <label className="form-label col-12 col-lg-2">Password confirmation</label>
                          <div className="col-12 col-lg-8">
                            <HubInputField
                              inputId="password_confirmation"
                              isRowBased={true}
                              isRequired={false}
                              field={field}
                              error={error}
                              // inputLabel="Password confirmation"
                              inputType="password"
                            />
                          </div>
                        </div>
                      )}
                    />
                  </div>
                </div>

                {/* <SignatureModal
                  isOpen={isSignatureModalVisible}
                  onClose={() => setIsSignatureModalVisible(false)}
                  onSave={handleSaveSignature}
                /> */}

                <div className="card mt-3 mb-3">
                  <div className="card-header">
                    <h1 className="mb-0">By Logging in, You Agree to the Terms of the Below Business Associates
                      Agreement
                    </h1>
                  </div>

                  <div className="card-body overflow-auto" style={{maxHeight: "400px"}}>
                    <BAAComponent/>
                  </div>
                </div>

                <button disabled={userLoading} className="btn btn-primary d-flex" type="submit">
                  {userLoading ? (
                    <i className="spinner-border text-white me-2" style={{width: `24px`, height: `24px`}}></i>
                  ) : null}
                  <p className="col-auto mb-0">Save</p>
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="bg-white mt-3"><FooterText footerType="black"/></div>
      </div>
    </div>
  );
};

export default HubUpdateUser;


